import Title from './components/Title';
import './App.css';
import { BrowserRouter, Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Navbar from './sidebar/Navbar';
import Collection from './pages/collection/Collection';
import Contents from './pages/contents/Contents';
// import Translation from './pages/translation/Translation'
// import DataVerification from './pages/translationdataverification/DataVerification'
// import VerificationData from './pages/verification/VerificationData';
// import Sagigation from './pages/sagigation/Sagigation';
// import Locate from './pages/locate/Locate';
// import Search from './pages/search/Search';
import GlobalProvider from './context/GlobalProvider';
import DataTransfer from './pages/datatransfer/DataTransfer';
import DownloadData from './pages/downloaddata/DownloadData';
import LocateMerge from './pages/locateMerge/LocateMerge';
import NotFound from './components/NotFound';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DomainPage from "./pages/admin/DomainPage"
import LoginForm from "./components/login/LoginForm";
import React, { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import { useAutoLogout } from "./hooks/useAutoLogout";
import ScrollToTopButton from "./components/ScrollToTopButton";
// import TraceRoute from './pages/locate/TracePage';
import TracePage from './pages/trace/TracePage'


const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const { handleLogin } = useContext(AuthContext);

  const onLogin = (token) => {
    handleLogin(token);
    navigate(from, { replace: true });
  };

  return <LoginForm onLogin={onLogin} />;
};

const App = () => {
  const { token, handleLogout } = useContext(AuthContext);
  useAutoLogout();



  return (
    <>
      <GlobalProvider>
        <BrowserRouter>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable="mouse"
            pauseOnHover={true}
            theme="colored"
            closeButton={true}
            style={{ zIndex: 10000 }}
          />
          {token ? (
            <div className='container-fluid'>
              <div className='d-flex text-center'>
                <Navbar />
                <div className='w-100'>
                  <Title handleLogout={handleLogout}/>
                </div>
              </div>
              <Routes>
                <Route path="/" element={<Collection />} />
                <Route path="/contents" element={<Contents />} />
                <Route path="/locate-merge" element={<LocateMerge />} />
                <Route path="/datatransfer" element={<DataTransfer />} />
                <Route path="/downloaddata" element={<DownloadData />} />
                <Route path="/domain" element={<DomainPage />} />
                <Route path="/trace" element={<TracePage />} />
                {/* <Route path="/translation" element={<Translation />} /> */}
                {/* <Route path="/segregate" element={<Sagigation />} /> */}
                {/* <Route path="/search" element={<Search />} /> */}
                {/* <Route path="/translationdataverification" element={<DataVerification />} /> */}
                {/* <Route path="/verification" element={<VerificationData />} /> */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          ) : (
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          )}
          <ScrollToTopButton />
        </BrowserRouter>
      </GlobalProvider>
    </>
  );
};

export default App;







